export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";